/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchExportTypesResponse } from './search-export-types-response';
import { SearchReportRecipientEmailResponse } from './search-report-recipient-email-response';


export interface SearchReportResponse { 
    id: string;
    name: string;
    exportFrequencyCode: string;
    exportTypes: Array<SearchExportTypesResponse>;
    reportRecipientEmails: Array<SearchReportRecipientEmailResponse>;
    accountNames: Array<string>;
    isSeparateProfitByAccounts: boolean;
}

